// Modules
import React, { useState, useEffect } from 'react';
import { getPhoneDigitsOnly } from './utils/phoneValidation';
import { replaceWithX } from './utils/replaceStringWithXs';
import { splitStringByIndex } from './utils/splitStringByIndex';

function formatEmail(email) {
  if (typeof email !== 'string' || !email || !/@/.test(email)) return '';

  const arr = email.split('@');

  // If the email is something like em@example.com return XX@example.com
  if (arr[0].length < 3) return replaceWithX(arr[0]) + '@' + arr[1];

  const { before, after } = splitStringByIndex(arr[0], arr[0].length - 2);

  return replaceWithX(before) + after + '@' + arr[1];
}

function formatPhone(phone) {
  if (typeof phone !== 'string' || !phone) return '';

  const copy = getPhoneDigitsOnly(phone) ?? '';

  const breakPoint = copy.length - 4;

  const { before, after } = splitStringByIndex(copy, breakPoint);

  const newStrStart = replaceWithX(before);

  const newStrEnd = after;

  return newStrStart + newStrEnd;
}

function formatGenericStr(args) {
  const { genericStr, breakPoint } = args;

  const { before, after } = splitStringByIndex(genericStr, breakPoint);

  return replaceWithX(before) + after;
}

function formatData(action) {
  const { type, payload } = action;

  switch (type) {
    case 'email':
      return formatEmail(payload);

    case 'phone':
      return formatPhone(payload);

    case 'genericStr':
      return formatGenericStr(payload);

    default:
      return '';
  }
}

const PrivacyDataDisplay = (props) => {
  const { email = '', phone = '', genericStr, breakPoint } = props;

  const [display, setDisplay] = useState('');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let displayVal = '';

    if (email) {
      displayVal = formatData({ type: 'email', payload: email });
    } else if (phone) {
      displayVal = formatData({ type: 'phone', payload: phone });
    } else if (genericStr && breakPoint) {
      displayVal = formatData({
        type: 'genericStr',
        payload: { genericStr, breakPoint },
      });
    }

    setDisplay(displayVal);
  });

  return <span>{display}</span>;
};

export default PrivacyDataDisplay;
